import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import Image from "../../../../img/outcome-roadmap.png";
import Links from "../../../Links";

const MuiProjectSection = styled(ProjectSection)`
  background: #2e2e2e;
`;

const Link = styled(Links)`
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  &:hover,
  &:focus {
    color: white;
    border-bottom: none;
  }
  &:focus {
    outline-color: white;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: auto;
  justify-content: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-large);

  @media (min-width: 500px) {
    grid-template-columns: auto;
  }
`;

const Button = styled(Links)`
  display: block;
  background-color: rgba(0, 0, 0, 0.05);
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  font-size: var(--font-size-text-small);
  &:hover,
  &:active {
    background-color: rgba(0, 0, 0, 0.3);
    color: #ffeb3b;
  }
  &:visited {
    color: white;
  }
  &:focus {
    outline-color: white;
  }
`;

function Outcomes() {
  return (
    <MuiProjectSection>
      <ProjectTitle title="Guru Outcomes" tag="2025" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="HTML">
          <Icons type="html-small" />
        </Badge>
        <Badge small title="CSS">
          <Icons type="css-small" />
        </Badge>
        <Badge small title="React">
          <Icons type="react-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
        <Badge small title="Agents & AI">
          <Icons type="ai-small" />
        </Badge>
      </ProjectSectionSkills>
      <ProjectDescription>
        <Link href="https://outcomes.gurusuite.xyz/" target="_blank" color="white">
          Outcomes
        </Link>{" "}
        is an app that helps users track objectives and key results in an outcome-based roadmap format. It organises
        tasks into <strong style={{ color: "#a4fc67" }}>Upcoming</strong>,{" "}
        <strong style={{ color: "#a4fc67" }}>Doing</strong>, and <strong style={{ color: "#a4fc67" }}>Finished</strong>{" "}
        columns and includes tracking for key results for each objective.
      </ProjectDescription>

      <ButtonGroup>
        <Button href="https://outcomes.gurusuite.xyz/" target="_blank" color="white">
          View App
        </Button>
      </ButtonGroup>

      <ProjectHeroImage src={Image} desktop lazy />
    </MuiProjectSection>
  );
}

export default Outcomes;
